import s from "../../bundled_deps/.pnpm/camelcase@8.0.0/bundled_deps/camelcase/index.js";
const u = "embercom-prosemirror-retry-upload", i = "file-guid";
function c(e) {
  e.attrs = Object.assign({}, e.attrs, {
    fileGUID: { default: "" },
    uploadFailed: { default: !1 },
    failureReason: { default: "" },
    retryable: { default: !0 }
  });
  const r = e.toDOM;
  return e.toDOM = (a) => {
    const t = a.attrs, l = r(a);
    if (Array.isArray(l) && l.length > 1 && (l[1][i] = t == null ? void 0 : t.fileGUID), (t == null ? void 0 : t.uploadFailed) === !0) {
      let o = [];
      if (t.retryable) {
        const n = { class: u };
        n[`data-${i}`] = t == null ? void 0 : t.fileGUID, o = ["a", n, "try again"];
      }
      return [
        "div",
        { class: "embercom-prosemirror-upload-failed" },
        [
          "div",
          { class: "embercom-prosemirror-upload-failed-inner" },
          [
            "div",
            { class: "embercom-prosemirror-upload-info" },
            d(),
            a.attrs.failureReason
          ],
          o
        ],
        l
      ];
    }
    return l;
  }, e;
}
function p(e, r) {
  var a;
  (a = r.target) != null && a.classList.contains(u) && (e == null || e.commands.retryUpload(r.target.dataset[s(i)]));
}
function m(e) {
  return e.type === "success" ? { fileGUID: "", uploadFailed: !1, failureReason: "" } : {
    uploadFailed: !0,
    failureReason: e.reason,
    retryable: e.retryable
  };
}
function d() {
  const e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  e.setAttributeNS(null, "fill", "red"), e.setAttribute("class", "interface-icon o__standard o__by-text"), e.setAttributeNS(null, "viewBox", "0 0 16 16");
  const r = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return r.setAttributeNS(null, "fill-rule", "oddeven"), r.setAttributeNS(
    null,
    "d",
    "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0-6.083a.701.701 0 0 1-.697-.621L6.88 4.615A1 1 0 0 1 7.872 3.5h.256a1 1 0 0 1 .993 1.115l-.424 3.68A.701.701 0 0 1 8 8.918zM8 12.5c-.714 0-1.25-.536-1.25-1.25S7.286 10 8 10s1.25.536 1.25 1.25S8.714 12.5 8 12.5z"
  ), e.appendChild(r), e;
}
export {
  i as UPLOAD_FILE_GUID,
  u as UPLOAD_RETRY_CLASS,
  p as handleUploadRetry,
  m as uploadResultToNodeAttrs,
  c as uploadable
};
